// The spinning avatar is brand art direction for the two Darkglass accounts,
// not a verification signal, so it stays in code rather than moving to
// users.is_verified. Kept keyed by username as well as id because most
// ProfileAvatar call sites (mentions, notification actors) have only a username.
const DARKGLASS_USERS = [{ username: 'darkglass', id: '17902a15-f04e-4dda-af99-09b63af35ad8' }];

export const isDarkglassUser = ({ username, id }: { username?: string; id?: string }) => {
  if (!username && !id) {
    return false;
  }
  return DARKGLASS_USERS.some((user) => user.id === id || user.username === username);
};
